import { actions } from 'actions';
import { createUniqueStr } from 'helpers';

const initialState = {
  status: null,
  items: [],
};

/**
 * 調整プログラム設定情報を管理する
*/
const programSettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.DELETE_PROGRAM_SETTING:
      return {
        status: createUniqueStr(),
        items: state.items.filter(state => state.product_cd !== action.product_cd)
      };
    case actions.FETCH_PROGRAM_SETTING:
      return {
        status: createUniqueStr(),
        items: [
          ...state.items.filter(state => state.product_cd !== action.product_cd),
          action.item
        ]
      };
    case actions.FETCH_PROGRAM_SETTINGS:
      return {
        status: createUniqueStr(),       
        items: action.items
      };
    case actions.REGIST_PROGRAM_SETTING:
    case actions.UPDATE_PROGRAM_SETTING:    
    default:
      return state;
  }
};

export default programSettingReducer;